import React from 'react';
import { GridItem, Box } from '@chakra-ui/react';
import { RenderIf } from '../RenderIf/RenderIf';
import SidebarInspections from './SidebarInspections';
import SidebarSettings from './SidebarSettings';
import { useTokens } from '../../../context/TokenProvider';
const SubNavWrapper = ({ sidebarSection }) => {
    const tokens = useTokens();
    const styles = {
        subNavOuter: {
            bg: tokens.Layer02,
            marginLeft: '68px',
            zIndex: 1,
            w: '264px',
            'box-shadow': '-2px 0px 3px -2px rgba(0,0,0,0.25) inset',
            '-webkit-box-shadow': '-2px 0px 3px -2px rgba(0,0,0,0.25) inset',
            '-moz-box-shadow': '-2px 0px 3px -2px rgba(0,0,0,0.25) inset',
        },
        nav: {
            mr: '68px',
        },
        subNavInner: {
            position: 'fixed',
            width: '264px',
        },
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(RenderIf, { condition: sidebarSection === 'settings' },
            React.createElement(GridItem, { "data-testid": "settings_sidebars", area: "nav", sx: styles.subNavOuter },
                React.createElement(Box, { sx: styles.subNavInner },
                    React.createElement(SidebarSettings, null)))),
        React.createElement(RenderIf, { condition: sidebarSection === 'inspections' },
            React.createElement(GridItem, { "data-testid": "inspections_sidebars", area: "nav", sx: styles.subNavOuter },
                React.createElement(Box, { sx: styles.subNavInner },
                    React.createElement(SidebarInspections, null))))));
};
export default SubNavWrapper;
